<template>
  <div class="index">
    <el-row type="flex" justify="left" style="margin-top: 10px; padding: 0 10px">
      <el-col :span="6">
        <div class="bg-container">
          <p>
            系统将向<span style="color:#3BC492">{{ $store.state.responeList.total }}</span>人发送工资条 <br/>{{
              $store.state.responeList.total > 3 ? '（仅展示3人）' : ''
            }}
          </p>
          <div class="btn-container" v-if="$store.state.stepTwoShowState == 'customize'">
            <div @click="handleTab(item, index)" :style="
                activeindex == index ? 'background: #3BC492;color:#fff' : ''
              " class="header-btn" v-for="(item, index) in this.$store.state.stepThree.data" :key="index">
              {{ item.name }} <i class="el-icon-arrow-right"></i>
            </div>
          </div>

          <div class="btn-container" v-else>
            <div @click="handleTab(item, index)" :style="
                activeindex == index ? 'background: #3BC492;color:#fff' : ''
              " class="header-btn" v-for="(item, index) in $store.state.FilterList" :key="index">
            <span class="name">{{ item.name }}</span> <i class="el-icon-arrow-right"></i>
            </div>
          </div>

          <div class="packagenum" v-if="Packagecheck.flag">套餐剩余条数：<span style="color:#FF0000">{{Packagecheck.content}}</span>条</div>
          <div class="packageno" v-if="Packagecheck.flag">
            <i class="el-icon-info"></i>
            <div>您当前套餐条不足,请到"我的套餐"去升级套餐后再发送。</div>
          </div>
          <div class="packageno" v-if="Illegalcheck.flag">
            <i class="el-icon-info"></i>
            <div>
              {{Illegalcheck.content}}
            </div>
          </div>
          <div class="packageno" v-if="Repeatcheck.flag">
            <i class="el-icon-info"></i>
            <div>
              {{Repeatcheck.content}}
            </div>
          </div>
        </div>
      </el-col>
      <el-col class="bg-container" :span="12" style="margin: 0 10px">
        <div>
          <div class="nameshow">
            员工<span style="color: #52cb9f">{{ showname }}</span>将看到以下工资条
          </div>
          <!-- 自定义 -->
          <div v-if="$store.state.stepTwoShowState == 'customize'" v-html="$store.state.stepThree.nowHtml"></div>
          <!--  纵向-->
          <div v-if="$store.state.stepTwoShowState == 'portrait'">
            <div class="portraitedit-container">
              <img src="@/assets/phonebottom.png" alt />
              <div class="portrait-container">
                <table >
                  <thead>
                    <tr>
                      <td colspan="2" style="
                          font-size: 12px;
                          font-family: PingFangSC-Medium, PingFang SC;
                          font-weight: 500;
                          color: #ffffff;
                          line-height: 17px;
                        ">
                        {{ orgInfo.orgName }}</br>{{$store.state.responeList.query.salaryType}}明细表({{
                          new Date($store.state.stepOne.value2).getFullYear() +
                          '年' +
                          (parseInt(
                            new Date($store.state.stepOne.value2).getMonth()
                          ) +
                            1) +
                          '月'
                        }})
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, name) in $store.state.stepThree.nowHtml ||{}"
                     v-if="
                        $store.state.nullflag &&
                        item &&
                        $store.state.zeroFlag &&
                        item != 0
                      ">
                      <td class="nameTd">{{ name .replace(/\\"/g, '"')}}</td>
                      <td class="itemTd">{{ item }}</td>
                    </tr>

                    <tr v-for="(item, name) in $store.state.stepThree.nowHtml ||
                      {}" v-if="!$store.state.nullflag && !$store.state.zeroFlag">
                      <td class="nameTd">{{ name.replace(/\\"/g, '"') }}</td>
                      <td class="itemTd">{{ item }}</td>
                    </tr>

                    <tr v-for="(item, name) in $store.state.stepThree.nowHtml ||
                      {}" v-if="
                        $store.state.nullflag && !$store.state.zeroFlag && item
                      ">
                      <td class="nameTd">{{ name .replace(/\\"/g, '"')}}</td>
                      <td class="itemTd">{{ item }}</td>
                    </tr>
                    <tr v-for="(item, name) in $store.state.stepThree.nowHtml ||
                      {}" v-if="
                        !$store.state.nullflag &&
                        $store.state.zeroFlag &&
                        item !== '0'
                      ">
                      <td class="nameTd">{{ name.replace(/\\"/g, '"') }}</td>
                      <td class="itemTd">{{ item }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!-- 横向 -->
          <div v-if="$store.state.stepTwoShowState == 'landscape'">
            <div class="landscapeeditTitle">
              {{ orgInfo.orgName }}薪资明细表({{
                        new Date($store.state.stepOne.value2).getFullYear() +
                        '年' +
                        (parseInt(
                          new Date($store.state.stepOne.value2).getMonth()
                        ) +
                          1) +
                        '月'
                      }})
            </div>
            <div class="landscape-container">
              <table ref="table">
                <thead>
                  <tr>
                    <!-- 1 -->
                    <td v-for="(value, key) in $store.state.stepThree.nowHtml ||
                      {}" v-if="
                        $store.state.nullflag &&
                        value != 0 &&
                        $store.state.zeroFlag &&
                        value != ''
                      ">
                      {{ key.replace(/\\"/g, '"')}}
                    </td>

                    <!-- 2 -->
                    <td v-for="(value, key) in $store.state.stepThree.nowHtml ||
                      {}" v-if="!$store.state.nullflag && !$store.state.zeroFlag">
                      {{ key.replace(/\\"/g, '"') }}
                    </td>

                    <!-- 3 -->
                    <td v-for="(value, key) in $store.state.stepThree.nowHtml ||
                      {}" v-if="
                        $store.state.nullflag &&
                        !$store.state.zeroFlag &&
                        value != ''
                      ">
                      {{ key.replace(/\\"/g, '"') }}
                    </td>

                    <!-- 4 -->
                    <td v-for="(value, key) in $store.state.stepThree.nowHtml ||
                      {}" v-if="
                        !$store.state.nullflag &&
                        $store.state.zeroFlag &&
                        value != '0'
                      ">
                      {{ key.replace(/\\"/g, '"') }}
                    </td>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <!-- 1 -->
                    <td v-for="(value, key) in $store.state.stepThree.nowHtml ||
                      {}" v-if="
                        $store.state.nullflag &&
                        value != 0 &&
                        $store.state.zeroFlag &&
                        value != ''
                      ">
                      {{ value }}
                    </td>

                    <!-- 2 -->
                    <td v-for="(value, key) in $store.state.stepThree.nowHtml ||
                      {}" v-if="!$store.state.nullflag && !$store.state.zeroFlag">
                      {{ value }}
                    </td>

                    <!-- 3 -->
                    <td v-for="(value, key) in $store.state.stepThree.nowHtml ||
                      {}" v-if="
                        $store.state.nullflag &&
                        !$store.state.zeroFlag &&
                        value != ''
                      ">
                      {{ value }}
                    </td>

                    <!-- 4 -->
                    <td v-for="(value, key) in $store.state.stepThree.nowHtml ||
                      {}" v-if="
                        !$store.state.nullflag &&
                        $store.state.zeroFlag &&
                        value != '0'
                      ">
                      {{ value }}
                    </td>

                    <!-- <td
                      v-for="(value, key) in $store.state.stepThree.nowHtml ||
                      {}"
                      v-if="!$store.state.nullflag"
                    >
                      {{ value }}
                    </td> -->
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="bg-container">
          
          <div style="margin-top: 14px;width:100%;overflow:hidden" v-if="$store.state.stepTwoShowState != 'customize'">
            <el-checkbox style="float:left" @change="changnullflag" v-model="$store.state.nullflag">
              <span style="font-size: 14px; line-height: 14px; font-weight: 400">
                隐藏空值</span>
            </el-checkbox>
            <el-checkbox style="float:right" @change="changzeroFlag" v-model="$store.state.zeroFlag">
              <span style="font-size: 14px; line-height: 14px; font-weight: 400;float:right">
                隐藏0值</span>
            </el-checkbox>
          </div>


          <div class="underline"></div>

          <div class="switch-container flex">
            添加公告
            <span class="title-modify">
              <el-switch @change="handleNotice" v-model="notice" active-color="#3BC492" inactive-color="#c6c6c6"></el-switch>
            </span>
          </div>
          <div >
            <el-checkbox v-model="$store.state.stepThree.autoNotice" v-if="notice">弹出公告框</el-checkbox>
          </div>


          <div class="underline"></div>
          <div class="switch-container flex">
           <span>
            签后即焚  
            <el-tooltip class="item" effect="light"  content="表示签收后指定时间焚毁；时间只支持正整数。" placement="bottom"> <i class="el-icon-info"></i> </el-tooltip>
           </span>
            <span class="title-modify">
              <el-switch  @change="handleIncinerate" v-model="$store.state.stepThree.incinerate" active-color="#3BC492" inactive-color="#c6c6c6"></el-switch>
            </span>
          </div>
          <div v-show="$store.state.stepThree.incinerate" class="switch-container" style="margin-top: 2px">
          <span style="font-weight:normal">
            员工签收后  <el-input onafterpaste="this.value=this.value.replace(/\D/g,'')"  style="width: 70px" @input="changeValue" :disabled="false" v-model.number="incinerateTime" size="mini"  :max="maxNum" @blur="proving($event)"  ></el-input>
            <el-select size="mini"  class="incinerateType" v-model="incinerateType" placeholder="请选择" @change="changeType($event)">
              <el-option v-for="item in options" :key="item.value"  :label="item.label" :value="item"> </el-option>
            </el-select>
            失效</span>
          </div>
        


          <div class="underline"></div>
          <div class="switch-container">
            签收方式
            <span class="title-modify">
              <el-switch @change="handleSign" v-model="sign" active-color="#3BC492" inactive-color="#c6c6c6"></el-switch>
            </span>
          </div>
          <div  class="switch-container" style="margin-top: 10px">
            <el-radio-group style="width:100%" v-model="clickSign" :disabled="sign ? false : true" @change="handleClickSign">
              <el-radio v-if="!sign"  checked style="float:left">手写签名</el-radio>
              <el-radio v-else :label="false" style="float:left">手写签名</el-radio>
              <el-radio :label="true" style="float:right">一键签收</el-radio>
            </el-radio-group>
          </div>
         
          <div class="underline" v-if="$store.state.stepTwoShowState != 'customize'"></div>
          <p style="  margin: 7px 0 10px 0;  font-size: 14px; font-weight: 600; color: rgba(0, 0, 0, 0.7); ">
            发送方式
          </p>
          <div class="switch-container switch-container-color" v-if="$store.state.responeList.query.emailSend">
            <span style="font-size: 14px; font-weight: 400">邮件</span>
            <span class="title-modify">
              <el-switch :disabled="  $store.state.responeList.query.emailSend && $store.state.responeList.query.smsSend  ? switch2 || switch3 ? false : true: switch3 ? false : true
                " @change="handleSwitch1" v-model="switch1" active-color="#3BC492" inactive-color="#c6c6c6"></el-switch>
            </span>
          </div>

          <div class="switch-container switch-container-color" v-if="$store.state.responeList.query.smsSend">
            <span style="font-size: 14px; font-weight: 400">短信</span>
            <span class="title-modify">
              <el-switch :disabled=" $store.state.responeList.query.emailSend && $store.state.responeList.query.smsSend ? switch1 || switch3 ? false : true: switch3 ? false: true
                " @change="handleSwitch2" v-model="switch2" active-color="#3BC492" inactive-color="#c6c6c6"></el-switch>
            </span>

            <div v-if="switch2" class="remainingnum">
            <div v-if="userInfo.canUsedSms < $store.state.responeList.total" class="smsBox">
              <span style="color: #ea512e;font-size:12px;">
                短信剩余：{{ userInfo.canUsedSms>0?userInfo.canUsedSms:0}}条
              </span>
              <span style="color: #2e81f8; margin-left: 5px; cursor: pointer;font-size:12px;" @click="tobuysms">
                条数不足，去购买
                <i class="el-icon-arrow-right"></i>
              </span>
            </div>
            <div style="margin-top: 10px" v-if="signlist.length != 0">
              <el-checkbox v-model="smssign">选择自定义签名</el-checkbox>
            </div>
            <div v-if="smssign" style="margin-left: 25px">
              <div style="margin: 10px 0" v-for="item in signlist" v-if="item.status == 1">
                <el-radio v-model="signName" :label="item.signName">{{
                  item.signName
                }}</el-radio>
              </div>
            </div>
          </div>

          </div>
          <div class="switch-container switch-container-color">
            <span style="font-size: 14px; font-weight: 400">微信</span>
            <span class="title-modify">
              <el-switch :disabled=" $store.state.responeList.query.emailSend && $store.state.responeList.query.smsSend ? switch2 || switch1 ? false : true : switch1 && switch2 ? false: true  " @change="handleSwitch3" v-model="switch3" active-color="#3BC492" inactive-color="#c6c6c6"></el-switch>
            </span>
              <div class="switch-container switch-container-color" >
                <el-checkbox style="float:left"  @change="handleSwitch4" :disabled="!switch3" v-model="$store.state.verify">
                  <span style="font-size: 14px; line-height: 14px; font-weight: 400;margin-right:5px;">
                    姓名验证
                  </span>
                </el-checkbox>
                <el-tooltip class="item" effect="light" 
                    content="勾选后，在微信公众号、小程序里面查看工资条详情，需要用“姓名”做验证。"
                    placement="bottom">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
              </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="编辑公告内容" :visible.sync="dialogVisible" @close="closeNotice" :close-on-click-modal="false" width="40%">
      <p style="line-height: 40px">
        编辑公告内容 公告将附在工资条统一向员工展示
      </p>
      <el-input type="textarea" :rows="8" placeholder="在这里输入内容" maxlength="500" v-model="textarea"></el-input>
      <p style="margin-top: 20px">
        <el-upload class="upload-demo" :action="`${$http.defaults.baseURL}/salary-service/customer/uploadFile`" :headers="{
            Authorization: uploadToken,
          }" :on-success="handleSuccess" :on-erro="onerror" :on-change="fileChange" :before-upload="handleBefore" :on-remove="handleRemove" :limit="1" :file-list="uodatefile">
          <p style="color: #3bc492">
            <i class="el-icon-plus" style="margin-right: 6px; font-size: 12px"></i>添加附件
          </p>
        </el-upload>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelNotice" size="medium" round>&nbsp;&nbsp; 取 消 &nbsp;&nbsp;</el-button>
        <el-button type="primary" @click="enterNotice" size="medium" round>&nbsp;&nbsp; 确 定 &nbsp;&nbsp;</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Button, Upload } from "iview";
import Cookie from "js-cookie";
import moment from "moment";

import {
  checkIllegal,
  checkPackage,
  checkRepeat,
  customerServiceInfo,
  getsmssigntotle,
} from "@/api/setUp";

export default {
  name: "step3",
  data() {
    return {
      maxNum: 24,
      incinerateTime: "", //具体时间
      incinerateType: "", //时间类型
      incinerate: false, //阅读即焚状态
      options: [
        {
          value: "D",
          label: "天",
          max: "31",
        },
        {
          value: "H",
          label: "小时",
          max: "24",
        },
        {
          value: "M",
          label: "分钟",
          max: "59",
        },
      ],
      autoNotice: false,
      orgInfo: [],
      htmlName: "",
      sign: true,
      clickSign: false,
      notice: false,
      switch1: true,
      switch2: true,
      switch3: true,
      userAuth: {},
      userInfo: "",
      sendState: "",
      isDisable: false,
      dialogVisible: false,
      textarea: "",
      uploadToken: "Bearer " + window.sessionStorage.getItem("token"),
      uodatefile: [],
      fileList: "",
      name: "",
      // uploadData:"",
      smssign: false,
      signlist: [],
      showname: "",
      activeindex: 0,
      signName: "",

      // 检测结果
      Illegalcheck: {
        flag: false,
        content: "",
      },

      Repeatcheck: {
        flag: false,
        content: "",
      },

      Packagecheck: {
        flag: false,
        content: "",
      },
    };
  },
  computed: {
    // getvalue(){
    //   this.uploadData.customerId = JSON.parse(Cookie.get('userInfo')).id
    // }
  },
  methods: {
    proving(e) {
      let val = e.target.value;
      if (!val || val == 0) {
        this.changeValue(1);
      }
    },
    changeValue(val) {
      this.incinerateTime =
        this.incinerateTime > this.maxNum ? this.maxNum : val;
      this.$store.commit("changeIncinerateTime", this.incinerateTime);
    },
    changeType(val) {
      this.incinerateType = val.label;
      this.$store.commit("changeIncinerateType", val.value);
      this.maxNum = val.max;
      this.incinerateTime = this.incinerateTime || 1;
    },
    async checkSend() {
      this.$store.commit("setsendLoading", true);
      let b = new Date(this.$store.state.stepOne.value2).getMonth() + 1;
      var data = {
        content: "",
        uploadFiles: [],
      };
      var sendNotice =
        this.$store.state.stepThree.sendNotice == ""
          ? data
          : this.$store.state.stepThree.sendNotice;
      let query = {
        clickSign: this.$store.state.stepThree.clickSign,
        // content: '',
        customerId: this.userInfo.id,
        emailSend: this.$store.state.stepThree.switch,
        month: b < 10 ? "0" + b : b,
        // name: '',
        notice: this.$store.state.stepThree.isNotice,
        nullFlag: this.$store.state.nullflag,
        open: this.$store.state.stepThree.switch3,
        salaryType: this.$store.state.stepOne.salaryType,
        sendNotice: sendNotice,
        // sendTime: this.sendTime,
        showState:
          this.$store.state.stepTwoShowState == "customize"
            ? 0
            : this.$store.state.stepTwoShowState == "portrait"
            ? 2
            : 1,
        sign: this.$store.state.stepThree.isSign,
        signName: this.$store.state.smssign,
        smsSend: this.$store.state.stepThree.switch2,
        templateId: this.$store.state.responeList.query.templateId,
        title: this.$store.state.responeList.query.title,
        year: new Date(this.$store.state.stepOne.value2).getFullYear(),
        zeroFlag: this.$store.state.zeroFlag,
        verId: this.$store.state.responeList.query.verId,
      };

      // this.$http
      //   .post(`${this.$http.defaults.baseURL}/salary-service/customer/checkRepeat`, {
      //     query: query,
      //   }).then(res => {
      //     console.log(res, 'ccc')
      //   })

      // 检测手机号邮箱是否重复

      // 违规字段
      // let [{ data: Illegalres }, { data: Packageres }, { data: Repeatres }] = await Promise.all([checkIllegal({ query }), checkPackage({ query })], checkRepeat({ query }))
      let [Illegalres, Packageres, Repeatres] = await Promise.all([
        checkIllegal({ query }),
        checkPackage({ query }),
        checkRepeat({ query }),
      ]);
      // let { data: Illegalres } = await checkIllegal({ query })
      // // 套餐套数
      // let { data: Packageres } = await checkPackage({ query })

      // let { data: Repeatres } = await checkRepeat({ query })

      const { data: numdata } = await customerServiceInfo();

      if (Illegalres.data.code == 505) {
        this.Illegalcheck = {
          flag: true,
          content: Illegalres.data.msg,
        };
      } else {
        this.Illegalcheck = {};
      }

      if (Repeatres.data.code == 500) {
        this.Repeatcheck = {
          flag: true,
          content: Repeatres.data.msg,
        };
      } else {
        this.Repeatcheck = {};
      }

      if (Packageres.data.code == 506) {
        this.Packagecheck = {
          flag: true,
          content: numdata[0].surplusNum,
        };
      } else {
        this.Packagecheck = {};
      }
      console.log(this.switch2);

      // 首先判断有无短信发送 $store.state.responeList.query.smsSend
      // 再次判断短信发送是否勾选this.switch2
      // 再次判断短信条数是否不足this.userInfo.canUsedSms < this.$store.state.responeList.total

      console.log(
        "首先判断有无短信发送",
        this.$store.state.responeList.query.smsSend
      );
      console.log("再次判断短信发送是否勾选", this.switch2);
      console.log(
        "再次判断短信条数是否不足",
        this.userInfo.canUsedSms < this.$store.state.responeList.total
      );

      console.log(Repeatres, "检测手机号邮箱是否重复");
      console.log(Illegalres, "违规字段");
      console.log(Packageres, "套餐套数");

      console.log(Illegalres.data.code, Packageres.data.code, "c3");

      if (this.$store.state.responeList.query.smsSend) {
        if (this.switch2) {
          if (
            this.userInfo.canUsedSms < this.$store.state.responeList.total ||
            Illegalres.data.code == 505 ||
            Packageres.data.code == 506
          ) {
            this.$store.commit("setsendFlag", true);
          } else {
            this.$store.commit("setsendFlag", false);
          }
        } else {
          if (Illegalres.data.code == 505 || Packageres.data.code == 506) {
            this.$store.commit("setsendFlag", true);
          } else {
            this.$store.commit("setsendFlag", false);
          }
        }
      } else {
        if (Illegalres.data.code == 505 || Packageres.data.code == 506) {
          this.$store.commit("setsendFlag", true);
        } else {
          this.$store.commit("setsendFlag", false);
        }
      }

      // 判断套餐条数.短信条数.违规字段是否可以发送
      // if (this.userInfo.canUsedSms < this.$store.state.responeList.total || Illegalres.code == 505 || Packageres.code == 506) {
      //   this.$store.commit('setsendFlag', true)
      // } else {
      //   this.$store.commit('setsendFlag', false)
      // }
      this.$store.commit("setsendLoading", false);
    },
    changzeroFlag(val) {
      this.$store.commit("setzeroFlag", val);
    },
    changnullflag(val) {
      this.$store.commit("setnullflag", val);
    },
    tobuysms() {
      // this.$router.push('/smsindex/smspackage')
      window.location.href = "https://sms.joyousoa.com/#/smsindex";
    },
    async getsmssignlist() {
      let { data } = await getsmssigntotle({
        status: 1,
      });
      this.signlist = data;
    },
    handleTab(val, index) {
      this.showname = val.name;
      if (this.$store.state.stepTwoShowState == "customize") {
        this.$store.commit("getSetpThreeHtml", val.c);
        this.htmlName = val.name;
        console.log(val, "自定义模板");
      } else {
        console.log(val, "上传模板");
        this.$store.commit("getSetpThreeHtml", JSON.parse(val.c));
        this.htmlName = val.name;
      }
      this.activeindex = index;
    },
    handleSign(val) {
      this.sign = val;
      this.$store.commit("changeIsSign", val);
      if (!val) {
        this.$store.commit("changeIncinerate", false);
        this.$store.commit("changeIncinerateTime", 0);
        this.$store.commit("changeIncinerateType", "");
      }
    },
    handleClickSign(val) {
      this.clickSign = val;
      this.$store.commit("changeClickSign", val);
    },
    handleNotice(val) {
      this.notice = val;
      this.dialogVisible = val;
      this.$store.commit("changeIsNotice", val);
      if (!val) {
        this.autoNotice = false;
      }
    },
    handleIncinerate(val) {
      if (!val) {
        this.$store.commit("changeIncinerateTime", 0);
        this.$store.commit("changeIncinerateType", "");
      } else {
        this.incinerateType = "小时";
        this.incinerateTime = 1;
        this.$store.commit("changeIncinerateTime", 1);
        this.$store.commit("changeIncinerateType", "H");
        this.handleSign(val);
      }
      console.log(this.$store, "90");
      this.$store.commit("changeIncinerate", val);
    },
    handleautoNotice() {},
    cancelNotice() {
      this.notice = false;
      this.dialogVisible = false;
      this.$store.commit("changeIsNotice", false);
    },
    closeNotice() {
      // this.isNotice = false;
      this.dialogVisible = false;
      // this.$store.commit("changeIsNotice", false);
    },
    enterNotice() {
      this.dialogVisible = false;
      var data = {};
      data.content = this.textarea;
      if (this.fileList.length) {
        data.uploadFiles = [
          {
            name: this.name,
            url: this.fileList,
          },
        ];
      }
      this.$store.commit("changeSendNotice", data);
    },
    handleSwitch1(val) {
      this.$store.commit("changeEmailSwitch", val);
    },
    handleSwitch2(val) {
      this.$store.commit("changeSmsSwitch", val);
      // 判断短信条数不足是否可以继续发送
      if (val) {
        if (
          this.userInfo.canUsedSms < this.$store.state.responeList.total ||
          this.Packagecheck.flag ||
          this.Illegalcheck.flag
        ) {
          this.$store.commit("setsendFlag", true);
        } else {
          this.$store.commit("setsendFlag", false);
        }
      } else {
        if (this.Packagecheck.flag || this.Illegalcheck.flag) {
          this.$store.commit("setsendFlag", true);
        } else {
          this.$store.commit("setsendFlag", false);
        }
      }
    },
    handleSwitch3(val) {
      this.$store.commit("changeWxSwitch", val);
      if (!val) {
        this.$store.commit("changeVerifySwitch", val);
      }
      console.log(val, "eeee");
    },
    handleSwitch4(val) {
      this.$store.commit("changeVerifySwitch", val);
    },
    async getUserAuth() {
      let res = await this.$http.get(
        `salary-service/customer/getPackageServiceByCustomer`
      );
      this.userAuth = res.data;

      // let stateRes = await this.$http.post(
      //   `salary-service/customer/salary/sendMode`,
      //   this.$store.state.stepThree.data,
      //   false
      // )

      // this.sendState = stateRes.data

      // if (this.sendState.smsSend == false) {
      //   this.$store.commit('changeSmsSwitch', false)
      // }
    },

    handleSuccess(response, file, fileList) {
      if (response.data) {
        this.$message({
          type: "success",
          message: "上传成功",
        });
        this.fileList = response.data;
        this.name = file.name;
      } else {
        this.$message({
          type: "info",
          message: `${response.message}`,
        });
      }
    },
    onerror() {},
    handleBefore(file) {},
    fileChange(file, fileList) {
      if (file.size / 1024 / 1024 > 10) {
        this.$message.error("附件大小不超过10MB");
        fileList.splice(-1, 1);
      }
    },
    handleRemove(file, fileList) {
      console.log(fileList);
      this.fileList = fileList;
    },

    getUserInfo() {
      this.$http.get("authority-center/common/user/info").then((res) => {
        this.posId = res.data.orgId;
        this.orgInfo = res.data;
        this.$http.get(`authority-center/org/${res.data.orgId}`).then((res) => {
          this.userInfo = res.data;
        });
      });
    },
  },
  created() {
    // 检查发送
    this.checkSend();
  },
  mounted() {
    this.showname = this.$store.state.responeList.data[0].name;
    this.getsmssignlist();
    this.getUserAuth();
    this.getUserInfo();
    // 判断发送按钮是否可点

    // this.switch1 = this.$store.state.stepThree.switch
    // this.switch2 = this.$store.state.stepThree.switch2
    // this.$store.commit(
    //   'getSetpThreeHtml',
    //   JSON.parse(this.$store.state.stepThree.data[0].c)
    // )
  },
  watch: {
    signName: {
      handler(newVal, oldVal) {
        this.$store.commit("getsmssign", newVal);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
.landscapeeditTitle {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 550;
  color: #000000;
  line-height: 22px;
  text-align: center;
  margin: 27px 0;
}
.landscape-container {
  overflow-x: auto;
  padding: 15px 0;

  > table {
    border-collapse: collapse;
    width: 200%;
    td {
      border: 1px solid #9e9c9c;
      text-align: center;
      min-width: 100px;
      height: 50px;
    }
    thead {
      tr {
        height: 50px;
        line-height: 50px;
        background-color: #3bc492;
        font-size: 14px;
        font-weight: 600;
        color: #fff;
      }
    }
  }
}

.portraitedit-container {
  height: 74vh !important;
  width: 42vh !important;
  margin: 0 auto;
  padding: 3vh 0.6vw 0 0.7vw;
  border-radius: 8px;
  background: url("../assets/phone.png") no-repeat;
  background-size: 100% 100%;
  position: relative;

  img {
    width: calc(100% - 1.1vw);
    height: 8vh;
    position: absolute;
    bottom: 1vh;
    left: 0;
    margin: 0 0.6vw 0 0.7vw;
  }
  .portrait-container {
    height: 60vh !important;
    width: 100%;
    margin: 0 auto;
    margin-top: 21px;
    overflow-y: auto;
    padding-left: 5px;
    > table {
      width: 100%;
      border-collapse: collapse;
      thead {
        background-color: #3bc492;
        text-align: center;
        color: #fff;
        td {
          padding: 8px 0 !important;
          font-size: 12px !important;
          line-height: 35px;
        }
      }

      tbody {
        tr {
          box-shadow: inset 0px 0px 1px 0px #c4cdd3;
          display: flex;
          justify-content: space-between;
          .nameTd {
            text-align: left;
            padding-left: 15px;
            width: 40%;
            word-break: break-all;
          }
          .itemTd {
            text-align: right;
            padding-right: 15px;
            flex: 1;
            word-break: break-all;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          td {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 450;
            color: #2c2d3a;
            line-height: 20px;
            padding: 10px 0;
          }
        }
      }
    }
  }
}

.header-btn {
  margin-top: 8px;
  text-align: center;
  line-height: 36px;
  height: 40px;
  cursor: pointer;
  background: rgba(255, 255, 255, 1);
  border-radius: 24px;
  border: 1px solid rgba(224, 234, 241, 1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #3bc492;
  line-height: 22px;
  padding: 0 24px;
  .name {
    width: 95%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  &:hover {
    background: rgba(59, 196, 146, 1);
    color: #fff;
  }
}
.switch-container {
  line-height: 30px;
  font-size: 14px;
  font-family: PingFangSC-Medium, Pi ngFang SC;
  font-weight: 550;
  color: #6f7276;
}
.switch-container-color {
  background: #f7f7f8;
  padding: 0 5px;
  margin-bottom: 8px;
}
.title-modify {
  color: #3bc492;
  float: right;
  font-size: 14px;
  line-height: 27px;
  cursor: pointer;
}

.bg-container {
  height: calc(100vh - 134px) !important;
  overflow-y: auto;
  background-color: #fff;
  padding: 14px 15px 0;
  border-radius: 8px;
  p {
    font-size: 14px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: rgba(44, 45, 58, 1);
  }
}
.el-dialog__body {
  padding: 15px 20px 10px !important;
}
.el-upload-list .el-upload-list__item {
  width: 100% !important;
  height: 100% !important;
}
.remainingnum {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 20px;
  .smsBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.nameshow {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #2c2d3a;
  line-height: 22px;
  margin-bottom: 5px;
}
.underline {
  height: 1px;
  width: 100%;
  border-bottom: 1px solid #000;
  opacity: 0.1;
  // background: #e4e7ed;
  margin: 7px 0 7px 0;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.packagenum {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 21px;
  padding-left: 11px;
  margin: 10px 0 0 0;
}
.packageno {
  margin-top: 11px;
  background: rgba(252, 235, 234, 0.5);
  border-radius: 4px;
  padding: 10px 10px 18px 9px;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #fc573c;
  line-height: 20px;
  i {
    line-height: 20px;
    margin-right: 3px;
  }
}

.incinerateType {
  line-height: 30px;
  margin-left: 8px;
  /deep/ .el-input__inner {
    width: 88px;
    height: 28px;
  }
  /deep/ .el-input__icon {
    height: 30px;
  }
}
</style>
